/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';

	const animation = () => {
		if($('.js-active-img').length) {
			$('.js-active-img').waypoint(function(direction){
				var activePoint = $(this.element);
				if(direction === 'down') { // scroll down
					activePoint.addClass(a);
				} else { // scroll up
					activePoint.removeClass(a);
				}
			}, { offset : '99%' });
		}
	}
	animation();
})(window.jQuery, window.FUNCTIONS);
